<template>
    <div class="flex py-1 z-90">
        <button class="flex items-center text-sm text-gray-warm-600 hover:text-red-600 leading-none focus:outline-none focus:shadow-none mr-6"
            @click.prevent.stop="open = true"
        >
            <i class="far fa-trash-alt mr-2 mb-px"></i>

            <span>{{ $t('Delete') }} <span class="hidden sm:inline">{{ $t('this property') }}</span></span>
        </button>


        <button class="flex items-center text-sm text-gray-warm-600 hover:text-green-warm-600 leading-none focus:outline-none focus:shadow-none"
            @click.prevent.stop="restore"
        >
            <i class="far fa-check-circle mr-2 mb-px"></i>

            <span>{{ $t('Restore') }}</span>
        </button>

        <transition
          enter-active-class="transition ease-out duration-100"
          enter-class="transform opacity-0"
          enter-to-class="transform opacity-100"
          leave-active-class="transition ease-in duration-100"
          leave-class="transform opacity-100"
          leave-to-class="transform opacity-0"
        >
            <div class="absolute top-0 left-0 flex items-center justify-center w-full h-full z-100"
                style="background-color: rgba(0, 0, 0, .45);"
                v-show="open"
                @click.prevent.stop="open = false"
            >
                <div v-if="open"
                    class="bg-white border border-gray-500 py-5 px-16 relative rounded shadow-xl"
                >
                    <div class="absolute px-3 py-1 text-xl text-gray-400 hover:text-gray-600 right-0 top-0 cursor-pointer"
                        @click.prevent.stop="close"
                    >
                        <i class="far fa-times-circle"></i>
                    </div>

                    <div class="mb-0">
                        <h2 class="text-lg text-center pb-2 text-red-600">
                            {{ $t('Delete this property') }}?
                        </h2>

                        <p class="text-sm text-center pb-4 text-gray-700 mb-0">
                           {{ $t('Once deleted, this property will no longer be available.') }}
                        </p>

                        <button type="button"
                            class="block bg-red-600 hover:bg-red-700 text-sm text-white hover:text-white uppercase tracking-wider leading-none px-12 py-4 mx-auto"
                            @click.prevent.stop="submit"
                        >
                            {{ $t('Delete') }}
                        </button>
                    </div>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
export default {
    props: {
        id: {},
    },

    data() {
        return {
            open: false,
            status: null,
        }
    },

    methods: {
        close() {
            this.open = false;
            this.status = null;
        },
        submit() {
            axios({
                method: 'delete',
                url: '/broker/properties/' + this.id,
            })
                .then(response => {
                    this.close();
                    this.$emit('deleted');
                }).catch(error => {
                    console.log(error.response.data);
                });
        },
        restore() {
            axios({
                method: 'post',
                url: '/broker/properties/' + this.id + '/restore',
            })
                .then(response => {
                    this.$emit('restored');
                }).catch(error => {
                    console.log(error.response.data);
                });

        },
    },
}
</script>
